<template>
  <div class="crud">
    <the-crud :title="title" :store="store" :columns="columns" :can-delete="true" :search="[]" :init-query-params="{
        ['organization.id'] : organizationId
      }" :hidden-query-params="{ ['organization.id']: organizationId}" ></the-crud>
  </div>
</template>

<script>
import TheCrud from '@/components/crud/TheCrud'
export default {
  data() {
    return {
      title: this.$t("contact-me.chat-center.providers"),
      store: "chatProviders",
      columns: [
        { index : 'id', label : '#id', sortable : true},
        { index : 'name', label : this.$t("common.name")},
        { index : 'type', label : this.$t('contact-me.chat-center.provider-type') },
      ]
    }
  },
  components: {
    TheCrud
  },
  computed: {
    organizationId() {
      return this.$store.getters["contactMe/getOrganizationId"];
    }
  }
}
</script>